import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { iconCheckmarkCircleTransparent } from '@/components/icons';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles } from '@/styles';
import { t } from 'i18next';
@customElement('fg-configurator-mobile-done')
export class FGConfiguratorMobileDone extends LitElement {
  render() {
    return html`
      <span>${iconCheckmarkCircleTransparent}</span>
      <h3>${t('content.configurator.configuratorSucces')}</h3>
    `;
  }

  static styles = [
    baseStyles,
    css`
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 24px;
      }

      span {
        display: block;
        width: 70px;
        height: 70px;
        color: var(--fg-success, var(--fg-fallback-success));
      }

      span svg {
        width: 100%;
        height: auto;
      }

      h3 {
        font-weight: 700;
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        :host {
          display: none;
        }
      }
    `,
  ];
}
